'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M511.9 19.3L508.8 3.6 493.1 .5c-45-9-114-14.7-180.7 19.7-40 20.7-77.3 54.8-107.7 107.8L96.4 128C45.2 213.3 13.2 266.7 .4 288l158.1 0 1 1 64 64 1 1 0 158.1c21.3-12.8 74.7-44.8 160-96l0-108.3c53.1-30.4 87.2-67.7 107.8-107.7 34.4-66.7 28.7-135.7 19.7-180.7zM272.4 352.7c23.3-6.4 44.6-13.6 64-21.6l0 57.8-64 38.4 0-74.5zM181.3 176c-8 19.4-15.2 40.7-21.6 64l-74.5 0 38.4-64 57.8 0zM334.4 62.8c45.9-23.7 94.6-23.8 133.2-18.1 5.8 38.6 5.6 87.3-18.1 133.2-25.7 49.9-81.9 101.3-201.7 131.5l-45-45c30.2-119.9 81.7-176 131.5-201.7zm74 81.2a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zM152.8 473.6c31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0c-45.3 45.3-38 152-38 152s106.7 7.3 152-38zm-40.6-32C95.7 458.1 57 455.4 57 455.4s-2.7-38.7 13.8-55.2c11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;